const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '1080P蓝光级高清视频播放，画质细腻色彩饱满，媲美影院观影体验',
    color: 'primary',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速加载',
    desc: '多线路智能调度，秒开不缓冲，高清在线影院流畅观看每一秒',
    color: 'accent',
  },
  {
    icon: 'ri-global-line',
    title: '海量片库',
    desc: '20000+高清电影免费看资源，涵盖全球热门影视和免费电视剧全集',
    color: 'secondary',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端适配',
    desc: '手机、平板、电脑完美适配，随时随地畅享免费影视大全',
    color: 'primary',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '纯净观影环境，无弹窗无恶意跳转，专注高清视频播放体验',
    color: 'accent',
  },
];

export default function FeaturesSection() {
  const getColorClasses = (color: string) => {
    switch (color) {
      case 'accent':
        return {
          iconBg: 'bg-accent-100',
          iconColor: 'text-accent-500',
        };
      case 'secondary':
        return {
          iconBg: 'bg-secondary-100',
          iconColor: 'text-secondary-500',
        };
      default:
        return {
          iconBg: 'bg-primary-100',
          iconColor: 'text-primary-500',
        };
    }
  };

  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            为什么选择6080影院？五大核心优势给你答案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat) => {
            const cls = getColorClasses(feat.color);
            return (
              <div
                key={feat.title}
                className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/60 text-center hover:border-primary-300 transition-all"
              >
                <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${cls.iconBg} mx-auto mb-4`}>
                  <i className={`${feat.icon} ${cls.iconColor} text-xl`}></i>
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-100 mb-2">
                  {feat.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {feat.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}